import { Domain } from '@/types/common/enums';

export function getSelectedDomain() {
  return window.config.DOMAIN === Domain.INTERNAL
    ? localStorage.country?.toUpperCase()
    : window.config.DOMAIN;
}
